import { gql } from '@apollo/client';

const Fragments = {
  reportItem: gql`
    fragment reportItem on ReportItem {
      reportId
      reportName
      reportFriendlyName
      orderNumber
      showInReportList
      showInPartner
      showInDocument
      isSensitiveInfo
      openMode
      reportType
      storedProcedureName
      countStoredProcedureName
    }
  `,
  reportFilterItem: gql`
    fragment reportFilterItem on ReportFilterItem {
      reportFilterId
      reportId
      filterCode
      filterCaption
      filterTypeId
      adaptiveDataSource
      displayMember
      allowNull
      allowMultipleSelection
      defaultValue
      orderNo
    }
  `,
  reportParameterItem: gql`
    fragment reportParameterItem on ReportParameterItem {
      reportParameterId
      reportId
      paramName
      reportParameterTypeId
      filterCode
      filterMember
      reportContextParameter
    }
  `,
  reportXDocumentTypeItem: gql`
    fragment reportXDocumentTypeItem on ReportXDocumentTypeItem {
      reportId
      documentTypeId
    }
  `,
  reportXPartnerTypeItem: gql`
    fragment reportXPartnerTypeItem on ReportXPartnerTypeItem {
      reportId
      partnerTypeId
    }
  `,
  reportXUserGroupItem: gql`
    fragment reportXUserGroupItem on ReportXUserGroupItem {
      reportId
      userGroupId
    }
  `
};

export default Fragments;
